import React from 'react';
import { motion } from 'framer-motion';
interface SignificanceFlowProps {
  significanceLevels: number[];
}
export const SignificanceFlow: React.FC<SignificanceFlowProps> = ({
  significanceLevels
}) => {
  return;
};